import React from 'react'

const Cp_perm = () => {
    return (
        <div className='container'>
            <h1>Write a program to print all permutations of a given string</h1>
            <p>A permutation, also called an “arrangement number” or “order,” is a rearrangement of the elements
             of an ordered list S into a one-to-one correspondence with S itself. A string of length n has n! 
             permutation. <br /><br />

             Below are the permutations of string ABC. <br />
ABC <br />ACB<br /> BAC<br /> BCA<br /> CBA<br /> CAB<br /></p>
<div class="containers">
        <div class="line number1 index0 alt2"><code class="comment">// C++ program to print all</code></div>
        <div class="line number2 index1 alt1"><code class="comment">// permutations with duplicates allowed</code>
        </div>
        <div class="line number3 index2 alt2"><code class="library">#include &lt;bits/stdc++.h&gt;</code></div>
        <div class="line number4 index3 alt1"><code class="library">using</code> <code
                        class="library">namespace</code> <code class="plain">std;</code></div>
        <div class="line number5 index4 alt2">&nbsp;</div>
        <div class="line number6 index5 alt1">&nbsp;</div>
        <div class="line number7 index6 alt2"><code class="comment">// Function to print permutations of string</code>
        </div>
        <div class="line number8 index7 alt1"><code class="comment">// This function takes three parameters:</code>
        </div>
        <div class="line number9 index8 alt2"><code class="comment">// 1. String</code></div>
        <div class="line number10 index9 alt1"><code class="comment">// 2. Starting index of the string</code></div>
        <div class="line number11 index10 alt2"><code class="comment">// 3. Ending index of the string.</code></div>
        <div class="line number12 index11 alt1"><code class="library">void</code> <code
                        class="plain">permute(string a, </code><code class="keywords">int</code> <code
                        class="plain">l, </code><code class="keywords">int </code> <code class="plain">r)</code></div>
        <div class="line number13 index12 alt2"><code class="plain">&#123;</code></div>
        <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Base case</code></div>
        <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">if</code> <code class="plain">(l == r)</code></div>
        <div class="line number16 index15 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout&lt;&lt;a&lt;&lt;endl;</code></div>
        <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">else</code></div>
        <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number19 index18 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Permutations made</code></div>
        <div class="line number20 index19 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">for</code> <code class="plain">(</code><code class="keywords">int</code>
                <code class="plain"> i = l; i &lt;= r; i++)</code></div>
        <div class="line number21 index20 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number22 index21 alt1">&nbsp;</div>
        <div class="line number23 index22 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Swapping done</code></div>
        <div class="line number24 index23 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">swap(a[l], a[i]);</code></div>
        <div class="line number25 index24 alt2">&nbsp;</div>
        <div class="line number26 index25 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Recursion called</code></div>
        <div class="line number27 index26 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">permute(a, l+1, r);</code></div>
        <div class="line number28 index27 alt1">&nbsp;</div>
        <div class="line number29 index28 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">//backtrack</code></div>
        <div class="line number30 index29 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">swap(a[l], a[i]);</code></div>
        <div class="line number31 index30 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number33 index32 alt2"><code class="plain">&#125;</code></div>
        <div class="line number34 index33 alt1">&nbsp;</div>
        <div class="line number36 index35 alt1"><code class="keywords">int</code> <code class="plain">main()</code>
        </div>
        <div class="line number37 index36 alt2"><code class="plain">&#123;</code></div>
        <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">string str = </code><code class="string">"ABC"</code><code class="plain">;</code>
        </div>
        <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">n = str.size();</code></div>
        <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">permute(str, 0, n-1);</code></div>
        <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">return</code> <code class="plain">0;</code></div>
        <div class="line number42 index41 alt1"><code class="plain">&#125;</code></div>
        <div class="line number43 index42 alt2">&nbsp;</div>

</div>
<div className='output'>
    <p><strong>Output</strong></p>
    ABC <br />
ACB <br />
BAC <br />
BCA <br />
CBA <br />
CAB <br />
</div>

        </div>
    )
}

export default Cp_perm
